/**
 TEST_EMAILS = "testsp+@ecotrak.com, QASPecotrak@gmail.com, QAecotrak@gmail.com, QASPecotrak@gmail.com, DEVecotrak@gmail.com"
*/

export const BASE_URL_ECOTRACK = "https://api.ecotrak.com/v1/"

export const BUILD_ENV= "PROD"
